<template><div><h1 id="personenereignisse" tabindex="-1"><a class="header-anchor" href="#personenereignisse"><span>Personenereignisse</span></a></h1>
<p>Personenereignisse — Ereignisse der Personen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Zeigt Aktivitäten der Organisation oder der <RouteLink to="/referenz/refs/ft.refdata.adr.html" title="Person">Person</RouteLink> selbst an. Die Ereignisse werden meist automatisch erfasst, z.B. bei Maling-Versänden, Fakturierungen, Zahlungseingang von Spenden oder bei der Teilnahme an einer Veranstaltung. Neben den Ereignissen werden auch <RouteLink to="/referenz/refs/ft.refdata.aktionen.html" title="Aktionen">Aktionen</RouteLink> angezeigt (gelb eingefärbt).</p>
<p>Pfad: <code v-pre>Personen → Ereignisse</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Datum</dt>
<dd>
<p>Ereignisdatum (z.B. Valutadatum bei Zahlungen oder Aussanddatum bei Mailings)</p>
</dd>
<dt>Bezug</dt>
<dd>
<p>Ein Ereignis mit Eintrag im &quot;Bezug&quot; gehört zu einer anderen Person, ist aber trotzdem von Interesse.<br>Folgende Einträge sind hier möglich:</p>
<table>
<thead>
<tr>
<th>Bezug</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Beschenkter</td>
<td>Empfänger einer Zusage, die durch einen &quot;Drittzahler&quot; bezahlt wird.</td>
</tr>
<tr>
<td>Drittzahler</td>
<td>Person, die für die Zahlung einer Zusage für den &quot;Beschenkten aufkommt (z.B. bei einer Geschenk-Mitgliedchaft).</td>
</tr>
<tr>
<td>Fremdadresse</td>
<td>Ereignis, das erfasst worden ist, als die Person nur als Fremdadresse erfasst war.</td>
</tr>
<tr>
<td>Haushalt (... und alle anderen Beziehungen)</td>
<td>Ereignis einer Beziehungsperson, die über die Beziehung mit der ausgewählten Person verbunden ist. In diesem Fall &quot;hh&quot; (&quot;Haushaltsbeziehung&quot;).</td>
</tr>
<tr>
<td>Kontakt</td>
<td>Ereignis einer Kontaktperson der ausgewählten Organisation.</td>
</tr>
<tr>
<td>Aktionen</td>
<td>Bei den Aktionen (gelb markiert) wird die Bezeichnung der Aktion angezeigt.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Status</dt>
<dd>
<p>Anzeige <RouteLink to="/referenz/refs/ft.refdata.ereigstat.html" title="Ereignisstatus">Ereignisstatus</RouteLink>. Die Status-Bezeichnung basiert Systemintern auf &quot;Ereignistyp&quot; und &quot;Ereigniskategorie&quot; und kann in der Tabelle <RouteLink to="/referenz/refs/ft.refdata.ereigstat.html" title="Ereignisstatus">Ereignisstatus</RouteLink> individuell angepasst werden.<br><br>Nachfolgend sind die wichtigsten Typ/Kat-Kombinatinen aufgeführt. Der dafür angezeigte Status ist je nach Organisation unterschiedlich, kann aber in der Tabelle <RouteLink to="/referenz/refs/ft.refdata.ereigstat.html" title="Ereignisstatus">Ereignisstatus</RouteLink> bearbeitet werden.</p>
<table>
<thead>
<tr>
<th>Typ/Kat</th>
<th>Beschreibung</th>
<th>Farbe</th>
</tr>
</thead>
<tbody>
<tr>
<td>A</td>
<td>Reaktivierung (Auflösung von Sperren).</td>
<td>-</td>
</tr>
<tr>
<td>C</td>
<td>Verdankung.</td>
<td>-</td>
</tr>
<tr>
<td>I</td>
<td>Initalereignis. Z.B. Mailingversand.</td>
<td>-</td>
</tr>
<tr>
<td>R?</td>
<td>Responsereignis. Z.B. Reaktion auf Mailing oder Warenbestellung</td>
<td>monetär = grün, nicht-monetär = blau</td>
</tr>
<tr>
<td>S</td>
<td>System-Ereignis</td>
<td>-</td>
</tr>
<tr>
<td>X?</td>
<td>Refuse-Ereignisse (Sperren)</td>
<td>rot</td>
</tr>
</tbody>
</table>
</dd>
<dt>Ereignis</dt>
<dd>
<p><RouteLink to="/referenz/refs/ft.refdata.ereigkopf.html" title="Ereignisse">Ereignis</RouteLink> und <RouteLink to="/referenz/refs/ft.refdata.ereigpos.html" title="Ereignispositionen">Ereignisposition</RouteLink>. Wie die Ereignisse und die zugehörigen Ereignispositionen angezeigt werden ist im Systemparameter &quot;AdrEreigBez&quot; definiert (verschiedene Anordnung/Kombination von Bezeichnung und Beschreibung möglich).</p>
</dd>
<dt>Response</dt>
<dd>
<p>Betrag in Franken. Der Responsewert wird inkl. MWST und Porti angezeigt. Allfällige Rabatte sind abgezogen.</p>
</dd>
<dt>Person</dt>
<dd>
<p>Vorname und Name der in Bezug stehenden Person. Anzeige nur, wenn Wert &quot;Bezug&quot; ausgefüllt ist.</p>
</dd>
<dt>Kanal</dt>
<dd>
<p><RouteLink to="/referenz/refs/ft.refdata.tblkommkanal.html" title="Kommunikationskanäle">Kommunikationskanal</RouteLink> des Ereignisses.</p>
</dd>
<dt>Adresse</dt>
<dd>
<p><RouteLink to="/referenz/refs/ft.refdata.telekom.html" title="Adressen">Adresse</RouteLink>. Wird dann angezeigt, wenn die Kommunikation nicht über die aktuelle Standardadresse erfolgt ist.</p>
</dd>
<dt>A</dt>
<dd>
<p>Ein Icon in Form einer Büroklammer zeigt an, dass zu diesem Ereignis mindestens 1 Attachment verknüpft ist.</p>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="ereignis-refuse-erfassen" tabindex="-1"><a class="header-anchor" href="#ereignis-refuse-erfassen"><span>Ereignis-Refusé erfassen ...</span></a></h3>
<p>Erfassen eines Refusé-Ereignisses mit manueller Eingabe von Ereignisstatus, Adresse und Refusé-Datum.</p>
<h3 id="ereignis-respons-erfassen" tabindex="-1"><a class="header-anchor" href="#ereignis-respons-erfassen"><span>Ereignis-Respons erfassen ...</span></a></h3>
<p>Erfassen eines nicht-monatären Respons-Ereignisses unter folgenden Bedingungen:</p>
<ul>
<li>Ausgangsereignis muss Status &quot;Inital&quot; haben</li>
<li>Ausgangsereignis muss in der Stammtabelle mit Situation &quot;RDI&quot; erfasst sein</li>
</ul>
<h3 id="loschen" tabindex="-1"><a class="header-anchor" href="#loschen"><span>löschen</span></a></h3>
<p>Löschen eines Ereignisses. Ereignisse mit Ereignisstatus R können nur beim Ereignistyp RDI (manuell erfasstes Ereignis ohne Wert) gelöscht werden.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.telekom.html" title="Adressen">Adressen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.aktionen.html" title="Aktionen">Aktionen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tbladrbez.html" title="Personenbeziehung">Beziehungen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.ereigkopf.html" title="Ereignisse">Ereignisse</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.ereigpos.html" title="Ereignispositionen">Ereignispositionen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.ereigstat.html" title="Ereignisstatus">Ereignisstatus</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.fremdadr.html" title="Fremdadressen">Fremdadressen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tblkommkanal.html" title="Kommunikationskanäle">Kanäle</RouteLink>, <RouteLink to="/manual/customer/zusagen.html" title="Zusage zu Person">Zusagen</RouteLink></p>
</div></template>


